import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";

export class FieldDropdownProperty extends PropertyBase{
    public label:string="Label";
    private formId:string='';

    public SetFormId(formId:string)
    {
        this.formId=formId;
        return this;
    }

    public SubRenderer(): React.ReactNode {
        var options:any[]=[];
        options.push({
            value:'',
            label:'Select a field'
        });
        let form:FormDTO=rednaoVar.FormList.find(x=>x.Id==this.formId);
        if(form!=null)
            for(let field of form.Fields)
            {
                options.push({
                    value:field.Id,
                    label:field.Label
                });
            }


        return (
            <SearchableSelect disabled={this.disabled} Label={this.label} Value={this.GetOptionValue(this.OptionsPropertyName)} onChange={e=>{this.SetOptionValue(e,this.OptionsPropertyName);this._onChange&&this._onChange(this.GetOptionValue()); this.toolItem.Refresh()}}>
                {options.map(x=>
                    <option key={x.value} value={x.value}>{x.label}</option>
                )}
            </SearchableSelect>
        )
    }

}